import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { Links } from 'src/class/links';
import { Servico } from 'src/class/servico';
import { newUsuario, objUsuario } from 'src/class/usuario';
import { SearchServicoPipe } from 'src/pipes/search-servico.pipe';
import { AuthService } from 'src/services/auth.service';
import { ContaService } from 'src/services/component/conta.service';
import { ServicoService } from 'src/services/component/servico.service';
import { DataService } from 'src/services/data.service';
import { LinksService } from 'src/services/links.service';
import { LocalhostService } from 'src/services/localhost.service';
import { ModalConfirmacaoService } from 'src/services/modal-confirmacao.service';
import { SiglaService } from 'src/services/siglaService.service';
import { ThemeService } from 'src/services/theme.service';
import { ToastService } from 'src/services/toast.service';

@Component({
  selector: 'app-agenda-servicos',
  templateUrl: './agenda-servicos.component.html',
  styleUrls: ['./agenda-servicos.component.css']
})
export class AgendaServicosComponent implements OnInit,OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  usr_id: string = "";
  usr_tipo: string = "";
  usr_token: string = "";

  usr_obj = new objUsuario;

  agenda_arr: any [] = [];

  pesquisa="";
  pesquisaLength = 0;
  pag = 1;
  contador = 5;
  pageSize = 5;
  pageIndex = 0;
  totalizador = 0;
  maxSize = 5;
  visualizando = this.contador;
  lightMode: any;
  modoView = false;
  modoViewNum = 12;

  private subscription: Subscription;

  linksAgenda: Links[] = [];

  servicos: Servico[] = [];
  displayedServicos: Servico[] = [];
  loading: boolean = true;
  sortedData: Servico[] = [];

  loader = this.loadingBar.useRef('http');
  empresaSigla: any | undefined;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private themeService: ThemeService,
    private linksService: LinksService,
    private router: Router,
    private route: ActivatedRoute,
    private toast: ToastService,
    private paginatorIntl: MatPaginatorIntl,
    private searchServicoPipe: SearchServicoPipe,
    private loadingBar: LoadingBarService,
    private modalConfirmacaoService: ModalConfirmacaoService,
    private servicoService: ServicoService,
    private localhostService: LocalhostService,
    private siglaService: SiglaService,
    private conta: ContaService,
    private authService: AuthService
  ) {
    this.subscription = this.themeService.lightMode$.subscribe(lightMode => {
      this.lightMode = lightMode;
    });

    this.paginatorIntl.itemsPerPageLabel = 'Itens por página:';
    this.paginatorIntl.nextPageLabel = 'Próxima página';
    this.paginatorIntl.previousPageLabel = 'Página anterior';
    this.paginatorIntl.firstPageLabel = 'Primeira página';
    this.paginatorIntl.lastPageLabel = 'Última página';

    // Personalize a indexação para começar em 1
    this.paginatorIntl.getRangeLabel = this.getPortugueseRangeLabel;

    // Alimenta o serviço com a empresaSigla
    // this.router.events.subscribe((event) => {
      // if (event instanceof NavigationEnd) {
        this.route.params
        .pipe(takeUntil(this.destroy$))
        .subscribe(params => {
          this.empresaSigla = params['empresaSigla'];
          this.siglaService.setEmpresaSigla(this.empresaSigla?.toString());
          this.servicoService.getServico(this.empresaSigla);
        });
      // }
    // });
   }

  ngOnInit() {

    // let servico = DataService.get("Servico");
    // console.log(servico)

    // if(servico != undefined){
    //   this.servicos = servico;
    //   this.loading = false;
    // }else{
    //   // this.loading = false;
    //   let servicoCache = localStorage.getItem("Servico")
    //   if(servicoCache != undefined){
    //     this.servicos = JSON.parse(servicoCache);
    //     DataService.set("Servico", JSON.parse(servicoCache));
    //     this.loading = false;
    //   }else{
    //     setTimeout(() => {
    //       this.loading = false;
    //     }, 500);
    //   }
    // }
    let modoView = localStorage.getItem("modoView");

    let modoViewNum = localStorage.getItem("modoViewNum");

    if(modoView){
      this.modoView = modoView == 'true' ? true : false
    }

    if(modoViewNum){
      this.modoViewNum = parseInt(modoViewNum);
    }

    try{
      const usr = JSON.parse(localStorage.getItem('user')!);
      // this.usr_id = usr.Id;
      // this.usr_tipo = usr.Tipo;
      // this.usr_token = usr.Token;
      this.usr_id = "1";
      this.usr_tipo = "M";
      this.usr_token = "usr.Token";
      if(this.usr_tipo != "M" && this.usr_tipo != "A"){
        this.router.navigate(['/home']);
      }
    }catch{
      this.router.navigate(['/home']);
    }

    this.linksAgenda = this.linksService.getLinksAgenda();
    this.changeDetectorRef.detectChanges();


    this.servicoService.getAllServico()
    .pipe(takeUntil(this.destroy$))
    .subscribe(
      (servicos: Servico[]) => {
        // console.log(servicos)
        // Faça algo com as notificações atualizadas
        this.servicos = servicos;

        this.loading = false;

        this.displayedServicos = this.servicos.slice(
          this.pageIndex * this.pageSize,
          (this.pageIndex + 1) * this.pageSize
        );

        this.route.queryParams.subscribe((params: any) => {
          // O parâmetro de consulta 'search' estará em params.search
          this.pesquisa = params.search ? params.search : '';
          // console.log(params)
          // Agora você pode usar o valor da pesquisa em sua função searchAgenda
          if(this.pesquisa != ''){
            this.searchServico();
          }
        });

      },
      error => {
        // console.error('Erro ao listar os Serviços:', error);
        this.router.navigate(['/home']);
      }
    );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  routerLink(rota: string, id: any = null){
    if(id != null){
      this.router.navigate([`${this.empresaSigla}/${rota}`, id]);
    }else{
      this.router.navigate([`${this.empresaSigla}/${rota}`]);
    }
  }

  searchServico(){
    const retorno = this.searchServicoPipe.transform(this.servicos, this.pesquisa);

    if (this.paginator) {
      this.paginator.firstPage();
    }

    this.displayedServicos = retorno;

    if(this.pesquisa == ""){
      this.displayedServicos = this.servicos.slice(
        this.pageIndex * this.pageSize,
        (this.pageIndex + 1) * this.pageSize
      );
      this.paginator.length = this.servicos.length;

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { search: null },
        queryParamsHandling: 'merge',
      });

    }else{

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { ['search']: this.pesquisa },
        queryParamsHandling: 'merge',
      });

      this.displayedServicos = retorno.slice(
        this.pageIndex * this.pageSize,
        (this.pageIndex + 1) * this.pageSize
      );
      if (this.paginator) {
        this.paginator.length = retorno.length;
      }
    }
  }

  handlePage(event: any) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;

    // Calcule o índice de início e fim dos itens a serem exibidos na página atual
    const startIndex = this.pageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;

    // Atualize os itens a serem exibidos na tabela
    this.displayedServicos = this.servicos.slice(startIndex, endIndex);

    // console.log(this.displayedServicos)
  }

  sortData(sort: Sort) {
    const data = this.servicos.slice();
    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
      this.servicos = this.sortedData
      return;
    }

    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';

      switch (sort.active) {
        // case 'id':
        //   return this.compare(a.id!, b.id!, isAsc);
        // case 'cep':
        //   return this.compare(a.cep.valor, b.cep.valor, isAsc);
        // case 'logradouro':
        //   return this.compare(a.logradouro.valor, b.logradouro.valor, isAsc);
        // case 'numero':
        //   return this.compare(a.numero.valor, b.numero.valor, isAsc);
        // case 'bairro':
        //   return this.compare(a.bairro.valor, b.bairro.valor, isAsc);
        // case 'localidade':
        //   return this.compare(a.localidade.valor, b.localidade.valor, isAsc);
        // case 'uf':
        //   return this.compare(a.uf.valor, b.uf.valor, isAsc);
        default:
          return 0;
      }
    });

    // console.log(this.sortedData)
    this.servicos = this.sortedData

    this.displayedServicos = this.servicos.slice(
      this.pageIndex * this.pageSize,
      (this.pageIndex + 1) * this.pageSize
    );
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  // Personalize a função getRangeLabel para começar em 1
  getPortugueseRangeLabel(page: number, pageSize: number, length: number): string {
    if (length === 0 || pageSize === 0) {
      return `0 de ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ?
      Math.min(startIndex + pageSize, length) :
      startIndex + pageSize;
    return `${startIndex + 1} - ${endIndex} de ${length}`;
  }

  reload(){
    try {
      this.servicos = [];
      this.loading = true;
      // this.getTotalTiposUsuarios();
      // this.getUsuario();
      this.loader.start()
      setTimeout(async () => {
        let servico = await this.servicoService.getServico(this.empresaSigla);
        // console.log(servico)

        if(servico != undefined){
          this.servicos = servico;
        }else{
          setTimeout(() => {
            this.loading = false;
            this.loader.complete()

          }, 500);
        }

        this.showInfo("Serviços atualizados com sucesso!!")
        this.loading = false;
        this.loader.complete()


      }, 1000);


    } catch (error) {
      this.showError("Ocorreu um erro na atualização da agenda")
      this.loader.complete()

    }

  }

  resetSearch(){
    this.pesquisa = "";
    this.displayedServicos = this.servicos.slice(
      this.pageIndex * this.pageSize,
      (this.pageIndex + 1) * this.pageSize
    );
    this.paginator.length = this.servicos.length;

    // Use o serviço Router para navegar para a mesma rota sem o parâmetro de consulta
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { search: null },
      queryParamsHandling: 'merge',
    });
  }

  pags(pags: any) {
    const target = pags as HTMLTextAreaElement;
    this.contador = parseInt(target.value)
    const total = this.contador * this.pag
    this.visualizando = total;
    if(this.visualizando > this.totalizador && (this.visualizando > 0 && this.totalizador > 0)){
      this.visualizando = this.totalizador;
    }
  }

  modoTabela(){
    this.modoView = true;
    localStorage.setItem("modoView", "true");
  }
  modoCard(){
    this.modoView = false;
    this.modoViewNum = 12;
    localStorage.setItem("modoView", "false");
    localStorage.setItem("modoViewNum", "12");
  }

  deletarServico(id: any){
    const index = this.servicos.findIndex(servico => servico.id === id);

    if (index !== -1) {

      let titulo = 'Tem certeza que deseja excluir o serviço?';
      let mensagem = `<div class="text-cor-padrao box-gen-card-list ag-mt-0">
                        <p class="ag-mb-5">
                        <span>${this.servicos[index].nome.valor}</span>
                      </p>
                      <p class="ag-mb-5">
                        <span>
                          R$ ${this.servicos[index].valor.valor}
                        </span>
                      </p>
                      <p class="ag-mb-5">
                        <span>
                          ${this.servicos[index].status.valor? "<i class='bi bi-circle-fill text-cor-sucesso ag-pr-5'></i>" : "<i class='bi bi-circle-fill text-cor-danger ag-pr-5'></i>"}
                          ${this.servicos[index].status.valor ? "Ativo" : "Desativado"}
                        </span>
                      </p>

                    </div>`;

      this.modalConfirmacaoService.openModal(titulo, mensagem).then(async (confirmation: boolean) => {
        if (confirmation) {
          // console.log('SIM!');
          // Encontrou um item com o ID correspondente, exclua-o

          const docId = this.servicos[index].id != null ? this.servicos[index].id?.toString() : "";

          await this.conta.p_getSiglaConta('contas', this.empresaSigla)
          .then((conta) => {
            // Faça algo com os dados obtidos
            // console.log('Dados da conta: criarAgenda', conta);
            this.localhostService.deleteDados(`${conta.id}_servicos`, { id: docId })
            .then((response: any) => {
              // console.log('Atualização bem-sucedida:', response);
              // Salve o array de volta no DataService
              // DataService.set("Agenda", this.agendas)
              // localStorage.setItem("Agenda", JSON.stringify(this.agendas))
              this.showSuccess(`Serviço deletado com sucesso`);

              this.displayedServicos = this.servicos.slice(
                this.pageIndex * this.pageSize,
                (this.pageIndex + 1) * this.pageSize
              );
            })
            .catch((error: any) => {
              // console.error('Erro ao deletar dados:', error);
              this.showError("Serviço não encontrada para exclusão \n" + error);
            });
          },
          (error: any) => {
            // console.error('Erro ao deletar dados:', error);
            // Trate o erro conforme necessário
          }).catch((error) => {
            // Trate o erro
            // console.log('Erro ao obter dados da conta:', error);
          });

          // this.servicos.splice(index, 1);

          // DataService.setItem("Servico", this.servicos);
          // localStorage.setItem("Servico", JSON.stringify(this.servicos))

          // this.showSuccess("Serviço deletada com sucesso");
          // this.displayedServicos = this.servicos.slice(
          //   this.pageIndex * this.pageSize,
          //   (this.pageIndex + 1) * this.pageSize
          // );

        } else {
          // console.log('NÃO');
        }
      });

    } else {
      // Não encontrou um item com o ID correspondente
      this.showError("Serviço não encontrado para exclusão");
    }
  }

  atualizarStatusServico(id: any){

    const index = this.servicos.findIndex((item: Servico) => item.id === id);

    if (index !== -1) {

      let titulo = 'Tem certeza que deseja alterar o status do serviço?';
      let mensagem = `<div class="text-cor-padrao box-gen-card-list ag-mt-0">
                        <p class="ag-mb-5">
                          <span>${this.servicos[index].nome.valor}</span>
                        </p>
                        <p class="ag-mb-5">
                          <span>
                            R$ ${this.servicos[index].valor.valor}
                          </span>
                        </p>
                        <p class="ag-mb-5">
                          <span class="text-cor-danger">Status atual: </span>
                          <span>${this.servicos[index].status.valor ? "Ativo" : "Desativado"}</span>
                        </p>
                        <p class="ag-mb-5">
                          <span class="text-cor-sucesso">Novo status: </span>
                          <span>${!this.servicos[index].status.valor ? "Ativo" : "Desativado"}</span>
                        </p>
                      </div>`;

      this.modalConfirmacaoService.openModal(titulo, mensagem).then(async (confirmation: boolean) => {
        if (confirmation) {
          // console.log('SIM!');
          // Atualize o item existente
          this.servicos[index].status.valor = !this.servicos[index].status.valor;

          const docId = this.servicos[index].id != null ? this.servicos[index].id?.toString() : "";
          const plainObject = JSON.stringify(this.servicos[index])
          const plainString = JSON.parse(plainObject)

          plainString.duracaoAtendimento.status = null;
          plainString.instrucoesConfirmacao.status = null;
          plainString.linkPagamento.status = null;
          plainString.nome.status = null;
          plainString.numeroPessoasPorHorario.status = null;
          plainString.valor.status = null;

          await this.conta.p_getSiglaConta('contas', this.empresaSigla)
          .then((conta) => {
            // Faça algo com os dados obtidos
            // console.log('Dados da conta: atualizarStatusServico', conta);
            this.localhostService.putDados(`${conta.id}_servicos`, docId!, plainString)
            .then((response: any) => {
              // console.log('Atualização bem-sucedida:', response);
              this.showSuccess(`Status do serviço ${this.servicos[index].nome.valor} alterado para ${this.servicos[index].status.valor ? "ativado" : "desativado"}`);
            })
            .catch((error: any) => {
              // console.error('Erro ao atualizar dados:', error);
              this.showError("Serviço não encontrado para atualização \n" + error);
            });

          },
          (error: any) => {
            // console.error('Erro ao atualizar dados:', error);
            // Trate o erro conforme necessário
          }).catch((error) => {
            // Trate o erro
            // console.log('Erro ao obter dados da conta:', error);
          });

          // this.servicos[index].status.valor = !this.servicos[index].status.valor;
          // localStorage.setItem("Servico", JSON.stringify(this.servicos))
          // this.showSuccess(`Status do serviço ${this.servicos[index].status.valor ? "ativado" : "desativado"}`);
        } else {
          // console.log('NÃO');
        }
      });


    } else {
      // O item não foi encontrado no array, você pode tratar isso conforme necessário
      this.showError("Agenda não encontrada para atualização");
    }
  }

  private showSuccess(msg: string){
    this.toast.showToast('<i class="bi bi-check-circle-fill " style="font-size: 25px;padding-right: 10px;"></i> ' + msg, 'success');
  }

  private showError(msg: string){
    this.toast.showToast('<i class="bi bi-x-circle-fill" style="font-size: 25px;padding-right: 10px;"></i> ' + msg, 'danger');
  }

  private showInfo(msg: string) {
    this.toast.showToast('<i class="bi bi-info-circle-fill" style="font-size: 25px;padding-right: 10px;"></i> ' + msg, 'info');
  }

}
